import {View, StyleSheet, PixelRatio} from 'react-native';
import AVText from 'src/components/elements/AVText';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import {
  ManualEntryButtonProps,
  ProductCategorySearchDescriberData,
  ScanDiscountCodeStylesDescriptor,
} from 'src/components/screens/cart/descriptor/Descriptor';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function getDoneButtonColor(): string {
  return Styles.primaryColor;
}
export function getReportButtonColor() {
  return null;
}

export function getReceiptStyles() {
  return {
    amount: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f1,
    },
    bold: {
      fontWeight: 'bold',
    },
    desc: {
      color: Styles.darkColor,
      flex: 1,
      fontSize: Styles.Fonts.f1,
    },
      header: {
        flex: 1,
        paddingBottom: Styles.Spacing.m3,
      },
      button: {
        marginTop: Styles.Spacing.m4,
      },
      dashStyle: {
        borderRadius: 100,
        height: PixelRatio.roundToNearestPixel(2),
        marginBottom: Styles.Spacing.m2,
        marginTop: Styles.Spacing.m2,
        overflow: 'hidden',
        width: '100%',
      },
      discount: {
        color: Styles.positiveColor,
      },
      supFeeStyle: {
        color: Styles.positiveColor,
      },
      labelStyle: {
        color: Styles.darkColor,
        fontFamily: Styles.FontFamily.robotoRegular,
        fontSize: Styles.Fonts.f7,
        fontWeight: '400',
        paddingVertical: 2,
      },
      totalLabel: {
        color: Styles.darkColor,
        fontFamily: Styles.FontFamily.robotoRegular,
        fontSize: Styles.Fonts.headerFont,
        fontWeight: '700',
      },
      remainingBalanceLabel: {
        color: Styles.lightGray,
        fontFamily: Styles.FontFamily.robotoRegular,
        fontSize: Styles.Fonts.sectionHeader,
        fontWeight: '400',
      },
      canteenRow: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
  };
}

export function getProductSearchEmptyContent(
  isloading?: boolean,
  isEmpty?: number,
): JSX.Element {
  return (
    isloading &&
    isEmpty === 0 && (
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: Styles.Spacing.m6,
          marginHorizontal: Styles.Spacing.m3,
        }}
      >
        <AVText
          accessibilityRole="text"
          style={{
            fontSize: Styles.Fonts.f2,
            fontWeight: '400',
            fontFamily: Styles.FontFamily.robotoRegular,
            textAlign: 'center',
            color: '#000',
          }}
        >
          {Localized.Labels.no_products_available}
        </AVText>
      </View>
    )
  );
}
export function searchTopContainerDescriptor(): {
  [index: string]: number | string;
} {
  return {top: -30};
}

export function getSelectedProductCategoryNameContent(
  props: ProductCategorySearchDescriberData,
): JSX.Element {
  return (
    <View style={props.styles.banner}>
      <AVText style={props.styles.bannerText}>{props.category}</AVText>
    </View>
  );
}
export function productCategoryflatListStyleDescriptor(
  props: ProductCategorySearchDescriberData,
): {
  [index: string]: number | string;
} {
  return props.styles.list;
}

export function getScanDiscountStyles(): ScanDiscountCodeStylesDescriptor {
  return StyleSheet.create({
    descriptionText: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f2,
      fontWeight: '700',
      marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
    },
  });
}
export function getManualEntryButton(props: ManualEntryButtonProps) {
  return (
    <RoundedButton
      containerStyle={styles.btnManualEntry}
      buttonType={ButtonType.outline}
      onPress={props.handleManualEntry}
      accessible={true}
      accessibilityLabel={Localized.Labels.manual_entry}
      accessibilityHint="Double tap to enter your discount code manually on the next screen"
      aria-label={Localized.Labels.manual_entry}
      text={Localized.Labels.manual_entry}
    />
  );
}
export function getColorForCheckoutButton() {
  return '#003349';
}

const styles = StyleSheet.create({
  btnManualEntry: {
    alignSelf: 'flex-end',
    marginTop: Styles.Spacing.m3,
    marginRight: Styles.Spacing.m3,
  },
});
export default {
  getDoneButtonColor,
  getReportButtonColor,
  getReceiptStyles,
  getProductSearchEmptyContent,
  searchTopContainerDescriptor,
  getSelectedProductCategoryNameContent,
  productCategoryflatListStyleDescriptor,
  getScanDiscountStyles,
  getManualEntryButton,
  getColorForCheckoutButton,
};
